/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Form as FormUi,
  Input,
  Dropdown,
  Container,
  Checkbox,
  TextArea,
  Icon,
} from "semantic-ui-react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import { MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import MandatoryMark from "../common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { MyInput } from "../dynamicComponent/myInputs";
import { DateData } from "../dynamicComponent/datepick";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import moment from "moment";
import {
  FIELD_IS_REQUIRED, INVALID_ADDRESS,
  INVALID_EMAIL, INVALID_GST_NUMBER,
  INVALID_LAND_LINE, INVALID_LATITUDE,
  INVALID_LONGITUDE, INVALID_MOBILE_NO,
  INVALID_NAME, INVALID_PAN_NUMBER, INVALID_PINCODE
} from "../../utils/validationConstant";
import { customerNo } from "../../utils/constant";

const ModalCreateConsignor = ({
  values,
  touched,
  errors,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  const [VendorsGroup, setVendorsGroup] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getAllVendors();
  }, []);
  let handleOpen = () => setmodalOpen(true);


  let handleClose = () => {
    setmodalOpen(false);
  };

  const handleSubmited = () => {
    if (
      values.consignorName &&
      values.email &&
      values.address &&
      values.pincode
    ) {
      handleSubmit();
      setmodalOpen(false);
    } else {
      handleSubmit();
      setmodalOpen(true);

    }
  };

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendors([])
          : setVendorsState(res.data.resultSet);
        getAllVendorsGroup();
        setmodalOpen(false);
      })
      .catch((err) => setVendors([]));
  };

  const getAllVendorsGroup = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
    })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVendorsGroup([])
          : setVendorsGroupState(res.data.resultSet);
        setmodalOpen(false)
      })
      .catch((err) => setVendors([]));
  };

  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: vendorIndex++,
      };
    });
    setVendors(result);
  };

  const checkForOrder = (name, data) => {
    setFieldValue("uom", data.value);
  };

  const setVendorsGroupState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vendorGroupName,
        key: item.vendorGroupId,
        value: vendorIndex++,
      };
    });
    setVendorsGroup(result);
  };

  const divideVendorsAndVendorGroup = (name, data) => {
    let temp = data.options.filter((ele) => {
      return ele.value == data.value[data.value.length - 1];
    })[0];
    temp.raw.transporterMasterId
      ? values.vendors.push(temp.raw.transporterMasterId)
      : values.vendor_groups.push(temp.raw.vendorGroupId);
    setFieldValue("allVendors", data.value);
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            className="ui icon create-consigner_button"
          >
            <i aria-hidden="true" className="add icon"></i>
          </Button>
        }
      >
        <Modal.Header className="page-title">{"Add Consignor"}</Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <div className="ui form">
              <Formiker>
                <div className="container-fluid animated slideInDown pad w3-white">
                  <div className="m-3 pl-3">
                    <div className="ui form">
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("consignor_code.title") || "Consignor Code"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="consignorCode"
                            placeholder={
                              t("consignor_code.placeholder") || "Code"
                            }
                          />
                        </FormUi.Field>
                        <FormUi.Field></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("consignor_name.title") || "Consignor Name"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="consignorName"
                            placeholder={
                              t("consignor_name.placeholder") || "Name"
                            }
                            error={
                              touched.consignorName && errors.consignorName
                                ? true
                                : false
                            }
                          />
                          {touched.consignorName && errors.consignorName ? (
                            <div className="error-msg">
                              {t(
                                `consignor_name.error_msg.${errors.consignorName}`
                              ) || errors.consignorName}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("email_id.title") || "Email Id"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="email"
                            placeholder={
                              t("email_id.placeholder") || "Email Id"
                            }
                            error={touched.email && errors.email ? true : false}
                          />
                          {touched.email && errors.email ? (
                            <div className="error-msg">
                              {t(`email_id.error_msg.${errors.email}`) ||
                                errors.email}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("mobile_number.title") || "Mobile No."}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="phone"
                            placeholder={
                              t("mobile_number.placeholder") || "Mobile No."
                            }
                            error={touched.phone && errors.phone ? true : false}

                          />
                          {touched.phone && errors.phone ? (
                            <div className="error-msg">
                              {t(`mobile_number.error_msg.${errors.phone}`) ||
                                errors.phone}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("landline_number.title") || "Landline No."}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="landLineNo"
                            placeholder={t("landline_number.placeholder") || "Landline No."}
                            error={touched.landLineNo && errors.landLineNo ? true : false}

                          />
                          {touched.landLineNo && errors.landLineNo ? (
                            <div className="error-msg">
                              {t(`landline_number.error_msg.${errors.landLineNo}`) ||
                                errors.landLineNo}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("contact_person.title") || "Contact Person Name"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="contactPersonName"
                            placeholder={t("contact_person.placeholder") || "Contact Person"}
                            error={touched.contactPersonName && errors.contactPersonName ? true : false}

                          />
                          {touched.contactPersonName && errors.contactPersonName ? (
                            <div className="error-msg">
                              {t(`contact_person.error_msg.${errors.contactPersonName}`) ||
                                errors.contactPersonName}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("company_address.title") || "Company Address"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            as={TextArea}
                            className="ui input"
                            name="address"
                            placeholder={
                              t("company_address.placeholder") ||
                              "Company Address"
                            }
                            error={
                              touched.address && errors.address ? true : false
                            }
                          />
                          {touched.address && errors.address ? (
                            <div className="error-msg">
                              {t(
                                `company_address.error_msg.${errors.address}`
                              ) || errors.address}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field ></FormUi.Field>
                      </FormUi.Group>

                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("latitude.title") || "Latitude"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="checkPointLattitude"
                            placeholder={
                              t("latitude.placeholder") || "Latitude"
                            }
                            error={
                              touched.checkPointLattitude &&
                                errors.checkPointLattitude
                                ? true
                                : false
                            }
                          />
                          {touched.checkPointLattitude &&
                            errors.checkPointLattitude ? (
                            <div className="error-msg">
                              {errors.checkPointLattitude}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field></FormUi.Field>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("longitude.title") || "Longitude"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="checkPointLongitude"
                            placeholder={
                              t("longitude.placeholder") || "Longitude"
                            }
                            error={
                              touched.checkPointLongitude &&
                                errors.checkPointLongitude
                                ? true
                                : false
                            }
                          />
                          {touched.checkPointLongitude &&
                            errors.checkPointLongitude ? (
                            <div className="error-msg">
                              {errors.checkPointLongitude}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group inline>
                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("pincode.title") || "Pincode"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="pincode"
                            placeholder={t("pincode.placeholder") || "Pincode"}
                            error={
                              touched.pincode && errors.pincode ? true : false
                            }
                          />
                          {touched.pincode && errors.pincode ? (
                            <div className="error-msg">
                              {t(`${errors.pincode}`) ||
                                errors.pincode}
                            </div>
                          ) : null}
                        </FormUi.Field>
                        <FormUi.Field></FormUi.Field>

                        <FormUi.Field width={3}>
                          <label className="labelName">
                            {t("gst_no.title") || "GST No."}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={5} className="display-grid-center-imp">
                          <Fieldmik
                            type="text"
                            className="ui input"
                            name="gstNumber"
                            placeholder={t("gst_no.placeholder") || "GST No."}
                            error={touched.gstNumber && errors.gstNumber ? true : false
                            }

                          />
                          {touched.gstNumber && errors.gstNumber ? (
                            <div className="error-msg">
                              {t(`${errors.gstNumber}`) || errors.gstNumber}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </div>
                </div>

              </Formiker>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isSubmitting ? "Loading..." : ""}
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={errors.gstNumber || errors.landLineNo || errors.pincode}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

const FormikBroadcast = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    consignorCode: yup.string().optional(),
    consignorName: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
    email: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Email, INVALID_EMAIL),
    phone: yup.string().matches(AllRegex.MobileNumber, INVALID_MOBILE_NO),
    landLineNo: yup.string().matches(AllRegex.LandlineNumber, INVALID_LAND_LINE),
    contactPersonName: yup.string().optional().matches(AllRegex.Name, INVALID_NAME),
    address: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Address, INVALID_ADDRESS),
    pincode: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_PINCODE),
    checkPointLattitude: yup.string().optional().matches(AllRegex.Latitude, INVALID_LATITUDE),
    checkPointLongitude: yup.string().optional().matches(AllRegex.Longitude, INVALID_LONGITUDE),
    gstNumber: yup.string().optional().matches(AllRegex.GSTIN, INVALID_GST_NUMBER),
    panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NUMBER),
    billingPartyId: customerNo == 1122 ? yup.string().required(FIELD_IS_REQUIRED) : yup.string().optional(),
    billingPartyBranchId: customerNo == 1122 ? yup.string().required(FIELD_IS_REQUIRED) : yup.string().optional()
  }),
  mapPropsToValues: (props) => ({
    consignorName: "",
    consignorCode: "",
    email: "",
    phone: "",
    landLineNo: "",
    contactPersonName: "",
    address: "",
    pincode: "",
    checkPointLattitude: "",
    checkPointLongitude: "",
    checkPointRadius: "",
    city: "",
    state: "",
    gstNumber: "",
    panNumber: "",
  }),

  handleSubmit(values, { setSubmitting, props, resetForm }) {
    CreateAxios({
      url: "consignorMaster",
      payload: { ...values },
    })
      .then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        resetForm();

      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.data ? err.data.message : err.message,
        });
      });
  },
})(ModalCreateConsignor);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("create_consignor")(FormikBroadcast)
);
